import { useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import ResponsiveImage from "components/ResponsiveImage";

const HiddenImage = styled("img", {
  shouldForwardProp: (prop) => prop !== "isHidden",
})(({ isHidden }) => ({
  display: isHidden ? "none" : "block",
}));

const ImageOnLoad = ({ src, alt, width, widthMobile, className, ...props }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOnLoad = () => setImageLoaded(true);

  return (
    <>
      <HiddenImage src={src} alt={alt} className={className} onLoad={handleOnLoad} isHidden={imageLoaded === false} />
      {!imageLoaded && (
        <ResponsiveImage src={src} alt={alt} className={className} width={width} widthMobile={widthMobile} {...props} />
      )}
    </>
  );
};

ImageOnLoad.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  widthMobile: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default ImageOnLoad;
